import { Col, Input, Row, Select, Table, Button, DatePicker } from "antd";
import { Field, Form, Formik } from "formik";
import moment from "moment";
import React, { FC, useEffect, useRef, useState } from "react";
import ButtonComponent from "../../../shared/components/ButtonComponent";

import { deserialize } from "serializr";
import CommonService from "../../../services/CommonService/common.service";
import LoginActivityReportService from "../../../services/ReportsService/LoginActivityReport.service";

import { MetaModel } from "../../../models/CourseModels/SubjectModel/subject.model";
import { FilterLoginActivity, LoginActivitySummaryModel } from "../../../models/ReportsModel/loginActivity.model";



import CalendarIcon from "../../../assets/icons/calendar-primary.svg";

const { RangePicker } = DatePicker;



interface LoginActivityReportProps {
  institutes: MetaModel[];
  user: any
}

const LoginActivityReport: FC<LoginActivityReportProps> = (props) => {
  const { institutes, user } = props;

  const [initialValues, setInitialValues] = useState<FilterLoginActivity>({
    type: "institute",
  });
  const [branches, setBranches] = useState<MetaModel[]>([]);
  const [boards, setBoards] = useState<MetaModel[]>([]);
  const [branchClassRooms, setBranchClassRooms] = useState<MetaModel[]>([]);
  const [sections, setSections] = useState<MetaModel[]>([]);
  const [loading, setLoading] = useState<boolean>(false);


  const [activitySummaryData, setActivitySummaryData] = useState<LoginActivitySummaryModel[]>([]);
  const formRef = useRef<any>();


  useEffect(() => {
    if (institutes.length && user?.roleName === "instituteadmin") {
      let currentInstituteID = Number(institutes[0].value)
      setInitialValues({ ...initialValues, instituteId: currentInstituteID })
      fetchBranches(currentInstituteID)
    }
  }, [institutes])

  const handleSubmit = (values: FilterLoginActivity) => {
    if (values.type === 'institute' && values.boardId && values.branchId) {
      fetchActivityReportByInst(values)
    } else if (values.type === 'onboard' && values.boardId) {
      fetchLearderboardByOnboard(values)
    }
  };

  const fetchActivityReportByInst = (values: FilterLoginActivity) => {
    setLoading(true)
    LoginActivityReportService.fetchLoginActivityReport(
      values,
      (data) => {
          setActivitySummaryData(data);
      },
      () => { },
      () => { setLoading(false) }
    );
  }

  const fetchLearderboardByOnboard = (values: FilterLoginActivity) => {
    setLoading(true)
    LoginActivityReportService.fetchLoginActivityReport(
      values,
      (data) => {
        setActivitySummaryData(data);
      },
      () => { },
      () => { setLoading(false) }
    );
  }

  // Download Report
  const handleDownload = (values: FilterLoginActivity) => {
    setLoading(true)
    LoginActivityReportService.downloadLoginActivityReport(
      values,
      (contents) => { },
      () => { },
      () => { setLoading(false) }
    );
  }

  const fetchBranches = (id: number) => {
    CommonService.fetchBranchesMeta(
      id,
      (data) => {
        const response = deserialize(MetaModel, data) as MetaModel[];
        setBranches(response);
      },
      () => { },
      () => { }
    );
  };

  const fetchBoards = () => {
    CommonService.fetchBoardsMeta(
      (data) => {
        const response = deserialize(MetaModel, data) as MetaModel[];
        setBoards(response);
      },
      () => { },
      () => { }
    );
  };

  const fetchSections = (branchId: number, classId: number) => {
    CommonService.fetchSectionsMeta(
      { ClassId: classId, BranchId: branchId },
      (data) => {
        const response = deserialize(MetaModel, data) as MetaModel[];
        setSections(response);
      },
      () => { },
      () => { }
    );
  };



  const fetchBranchClassRooms = (branchId: number) => {
    CommonService.fetchGradeMeta(
      branchId,
      (data) => {
        const meta = deserialize(MetaModel, data) as MetaModel[];
        setBranchClassRooms(meta);
      },
      () => { },
      () => { }
    );
  };


  useEffect(() => {
    fetchBoards();
  }, []);

  const clearForm = () => {
    user?.roleName === "admin" && setBranches([])
    setSections([])
    setBranchClassRooms([])
    setActivitySummaryData([]);
    setLoading(false);
  }




  return (
    <div className="classroom-reports">
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize
        innerRef={formRef}
      >
        {({ setFieldValue, values, resetForm, dirty }) => {
          return (
            <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <div className="institute-reports-filters__container">
                <Row
                  className="classroom-reports-filters__wrapper"
                  gutter={24}
                >
                  <Col span={24}>
                    <Row gutter={[24, 24]}>
                      <Col span={6}>
                        <div className="institute-reports-filter-field__container">
                          <div className="institute-reports-filter-field__label">
                            Filter by
                          </div>
                          <Field
                            disabled={user?.roleName === "instituteadmin" ? true : false}
                            as={Select}
                            name="type"
                            options={[
                              {
                                value: "institute",
                                label: "Institute",
                              },
                              {
                                value: "onboard",
                                label: "Self onboarded",
                              },
                            ]}
                            value={values?.type}
                            placeholder="Select Filter"
                            onChange={(value) => {
                              resetForm()
                              setFieldValue("type", value)
                            }}
                          ></Field>
                        </div>
                      </Col>
                      {values?.type == "institute" && (
                        <>
                          <Col span={6}>
                            <div className="institute-reports-filter-field__container">
                              <div className="institute-reports-filter-field__label">
                                Institute
                              </div>
                              <Field
                                disabled={user?.roleName === "instituteadmin" ? true : false}
                                as={Select}
                                name="instituteId"
                                value={values?.instituteId}
                                options={institutes}
                                placeholder="Select Institute"
                                onChange={(value) => {
                                  resetForm()
                                  setFieldValue("instituteId", value);
                                  value && fetchBranches(value);
                                }}
                              ></Field>
                            </div>
                          </Col>
                          <Col span={6}>
                            <div className="institute-reports-filter-field__container">
                              <div className="institute-reports-filter-field__label">
                                Branch
                              </div>
                              <Field
                                as={Select}
                                options={branches}
                                name="branchId"
                                value={values?.branchId}
                                placeholder="Select Branch"
                                onChange={(value) => {
                                  setFieldValue("branchId", value);
                                  setFieldValue("branchClassRoomId", null);
                                  setFieldValue("sectionId", null);
                                  setFieldValue("sectionSubjectId", null);
                                  fetchBranchClassRooms(value);
                                }}
                              ></Field>
                            </div>
                          </Col>
                        </>
                      )}

                      <Col span={6}>
                        <div className="institute-reports-filter-field__container">
                          <div className="institute-reports-filter-field__label">
                            Board
                          </div>
                          <Field
                            as={Select}
                            name="boardId"
                            options={boards}
                            value={values?.boardId}
                            placeholder="Select Board"
                            onChange={(value) =>
                              setFieldValue("boardId", value)
                            }
                          ></Field>
                        </div>
                      </Col>
                      <Col span={6}>
                        <div className="institute-reports-filter-field__container">
                          <div className="institute-reports-filter-field__label">
                            Class
                          </div>
                          <Field
                            as={Select}
                            name="branchClassRoomId"
                            options={branchClassRooms}
                            value={values?.branchClassRoomId}
                            placeholder="Select Class"
                            onChange={(value) => {
                              setFieldValue("branchClassRoomId", value);
                              setFieldValue("sectionId", null);
                              setFieldValue("sectionSubjectId", null);
                              values?.branchId &&
                                fetchSections(values?.branchId, value);
                            }}
                          ></Field>
                        </div>
                      </Col>

                      <Col span={6}>
                        <div className="institute-reports-filter-field__container">
                          <div className="institute-reports-filter-field__label">
                            Section
                          </div>
                          <Field
                            as={Select}
                            name="sectionId"
                            options={sections}
                            value={values?.sectionId}
                            placeholder="Select Section"
                            onChange={(value) => {
                              setFieldValue("sectionId", value);
                            }}
                          ></Field>
                        </div>
                      </Col>


                      <Col span={6}>
                        <div className="institute-reports-filter-field__container">
                          <div className="institute-reports-filter-field__label">
                            Date Range
                          </div>
                          <Field
                            name="date"
                            as={RangePicker}
                            value={[values?.startingDate ? moment(values?.startingDate, "YYYY-MM-DD") : undefined, values?.endingDate ? moment(values?.endingDate, "YYYY-MM-DD") : undefined]}
                            onChange={(dates) => {
                              if (dates?.length) {
                                setFieldValue("startingDate", moment(dates?.[0])?.format("yyyy-MM-DD"));
                                setFieldValue("endingDate", moment(dates?.[1])?.format("yyyy-MM-DD"));
                              } else {
                                setFieldValue("startingDate", 0);
                                setFieldValue("endingDate", 0);
                              }

                            }}
                            suffixIcon={
                              <img className="calendar__icon" src={CalendarIcon} />
                            }
                          />
                        </div>
                      </Col>
                      <Col span={6}>
                        <div className="institute-reports-filter-btn__wrapper">
                          <ButtonComponent
                            type="text"
                            buttonContent={"Clear Filters"}
                            onClick={() => {
                              resetForm();
                              clearForm()
                            }}
                          />
                          <ButtonComponent
                            type="primary"
                            loading={loading}
                            buttonContent={"Apply Filters"}
                            onClick={() => handleSubmit(values)}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
              <div className="institute-reports-search__container">
                <div></div>
                {activitySummaryData?.length ? (
                  <div>
                    <ButtonComponent
                      type="primary"
                      buttonContent={"Download Report"}
                      onClick={() => handleDownload(values)} />
                  </div>
                ) : (
                  ""
                )}
              </div>
            </Form>
          );
        }}
      </Formik>
      <Table
        columns={[
          {
            title: 'Name',
            dataIndex: 'studentname',
            key: 'name',
            width: 150,
            fixed: 'left',
            render: (text, row) => <div>
              <strong>{row['studentname']}</strong>
            </div>,

          },
          {
            title: 'Grade',
            dataIndex: 'grade',
            key: 'grade',
            width: 100,
          },
          {
            title: 'Section',
            dataIndex: 'section',
            key: 'section',
            width: 100,
          },
          {
            title: 'Logins',
            dataIndex: 'login',
            children: [
              {
                title: 'Login Time',
                render: (text, row) => <div className="sub_div">
                  {row['login']?.map(data => <div>{data.logintime}</div>)}
                </div>
              },
              {
                title: 'Long Used',
                render: (text, row) => <div className="sub_div">
                  {row['login']?.map(data => <div>{Number(data.timeused).toFixed(2)}</div>)}
                </div>
              },
            ]
          },
          {
            title: 'Contents Viewed',
            dataIndex: 'contentviwed',
            width: 400,
            // render: (text, row) => <div className="sub_div">
            //   {
            //     row['contentviwed']?.map(data => <div >
            //       <div className="sub_row_div">
            //         <strong style={{ padding: '0 10px', width: 100 }}>{data.subjectname}</strong>
            //         <div className="sub_div">
            //           {data?.chapter?.map(chapter => (<div className="sub_row_div">
            //             <strong style={{ padding: '0 10px', width: 100 }}>{chapter.chaptername}</strong>
            //             <div className="sub_div">
            //               {chapter['content']?.map(content => <strong style={{ padding: '0 10px', width: 100 }}>{content.name}</strong>)}
            //             </div>
            //           </div>
            //           ))}
            //         </div>
            //       </div>
            //     </div>)
            //   }
            // </div>,
            children: [
              {
                title: 'Subject name',
                render: (text, row) => <div className="sub_div">
                  {
                    row['contentviwed']?.map(data => <div >
                      <div className="sub_row_div">
                        <div  className="data_text" style={{ width: 100 }}>{data.subjectname}</div>
                        <div className="hidden_div">
                          {data?.chapter?.map(chapter => (<div className="sub_row_div">
                            <strong  className="data_text" style={{ minWidth: 100 }}>{chapter.chaptername}</strong>
                            <div className="sub_div">
                              {chapter['content']?.map(content => <strong  className="data_text" style={{ width: 100 }}>{content.name}</strong>)}
                            </div>
                          </div>
                          ))}
                        </div>
                      </div>
                    </div>)
                  }
                </div>
              },
              {
                title: 'Chapter name',
                render: (text, row) => row['contentviwed']?.map(data =>
                  <div className="sub_div">
                    {data?.chapter?.map(chapter => (<div className="sub_row_div">
                      <div  className="data_text" style={{ minWidth: 100 }}>{chapter.chaptername}</div>
                      <div className="hidden_div">
                        {chapter['content']?.map(content => <strong  className="data_text" style={{ width: 100 }}>{content.name}</strong>)}
                      </div>
                    </div>
                    ))}
                  </div>

                )
              },
              {
                title: 'Content name',
                render: (text, row) => <div className="sub_div">
                  {
                    row['contentviwed']?.map(data =>
                      data?.chapter?.map(chapter => (<div className="sub_row_div">
                        <div className="sub_div">
                          {chapter['content']?.map(content => <div  className="data_text" style={{ width: 100 }}>{content.name}</div>)}
                        </div>
                      </div>
                      ))
                    )
                  }
                </div>
              },
              {
                title: 'Quick Quiz',
                render: (text, row) => <div className="sub_div">
                  {
                    row['contentviwed']?.map(data =>
                      data?.chapter?.map(chapter => (<div className="sub_row_div">
                        <div className="hidden_div">
                          {chapter['content']?.map(content => <div  className="data_text" style={{ width: 100 }}>{content.name}</div>)}
                        </div>
                        <div className="sub_div">
                          {chapter['content']?.map(content => <div  className="data_text" style={{ width: 100 }}>{content.quickquiz}</div>)}
                        </div>
                      </div>
                      ))
                    )
                  }
                </div>
              },
            ]
          },
          {
            title: 'Worksheet(PDF)',
            dataIndex: 'pdfviwed',
            width: 400,
            children: [
              {
                title: 'Subject name',
                render: (text, row) => <div className="sub_div">
                  {
                    row['pdfviwed']?.map(data => <div >
                      <div className="sub_row_div">
                        <div className="data_text" style={{ width: 100 }}>{data.subjectname}</div>
                        <div className="hidden_div">
                          {data?.chapter?.map(chapter => (<div className="sub_row_div">
                            <strong  className="data_text" style={{ minWidth: 100 }}>{chapter.chaptername}</strong>
                            <div className="sub_div">
                              {chapter['content']?.map(content => <strong  className="data_text" style={{ width: 100 }}>{content.name}</strong>)}
                            </div>
                          </div>
                          ))}
                        </div>
                      </div>
                    </div>)
                  }
                </div>
              },
              {
                title: 'Chapter name',
                render: (text, row) => row['pdfviwed']?.map(data =>
                  <div className="sub_div">
                    {data?.chapter?.map(chapter => (<div className="sub_row_div">
                      <div  className="data_text" style={{ minWidth: 100 }}>{chapter.chaptername}</div>
                      <div className="hidden_div">
                        {chapter['content']?.map(content => <strong  className="data_text" style={{ width: 100 }}>{content.name}</strong>)}
                      </div>
                    </div>
                    ))}
                  </div>

                )
              },
              {
                title: 'Content name',
                render: (text, row) => <div className="sub_div">
                  {
                    row['pdfviwed']?.map(data =>
                      data?.chapter?.map(chapter => (<div className="sub_row_div">
                        <div className="sub_div">
                          {chapter['content']?.map(content => <div  className="data_text" style={{ width: 100 }}>{content.name}</div>)}
                        </div>
                      </div>
                      ))
                    )
                  }
                </div>
              }
            ]
          },
          {
            title: 'Exercise quiz',
            dataIndex: 'excercise',
            width: 400,
            children: [
              {
                title: 'Subject name',
                render: (text, row) => <div className="sub_div">
                  {
                    row['excercise']?.map(data => <div >
                      <div className="sub_row_div">
                        <div  className="data_text" style={{ width: 100 }}>{data.subjectname}</div>
                        <div className="hidden_div">
                          {data?.chapter?.map(chapter => (<div className="sub_row_div">
                            <strong  className="data_text" style={{ minWidth: 100 }}>{chapter.chaptername}</strong>
                            <div className="sub_div">
                              {chapter['content']?.map(content => <strong  className="data_text" style={{ width: 100 }}>{content.name}</strong>)}
                            </div>
                          </div>
                          ))}
                        </div>
                      </div>
                    </div>)
                  }
                </div>
              },
              {
                title: 'Chapter name',
                render: (text, row) => row['excercise']?.map(data =>
                  <div className="sub_div">
                    {data?.chapter?.map(chapter => (<div className="sub_row_div">
                      <div  className="data_text" style={{ minWidth: 100 }}>{chapter.chaptername}</div>
                      <div className="hidden_div">
                        {chapter['content']?.map(content => <strong  className="data_text" style={{ width: 100 }}>{content.name}</strong>)}
                      </div>
                    </div>
                    ))}
                  </div>

                )
              },
              {
                title: 'Excercise name',
                render: (text, row) => <div className="sub_div">
                  {
                    row['excercise']?.map(data =>
                      data?.chapter?.map(chapter => (<div className="sub_row_div">
                        <div className="sub_div">
                          {chapter['content']?.map(content => <div  className="data_text" style={{ width: 100 }}>{content.name}</div>)}
                        </div>
                      </div>
                      ))
                    )
                  }
                </div>
              }
            ]
          },
          {
            title: 'Activity',
            dataIndex: 'activityviwed',
            width: 400,
            children: [
              {
                title: 'Subject name',
                render: (text, row) => <div className="sub_div">
                  {
                    row['activityviwed']?.map(data => <div >
                      <div className="sub_row_div">
                        <div  className="data_text" style={{ width: 100 }}>{data.subjectname}</div>
                        <div className="hidden_div">
                          {data?.activities?.map(chapter => (<div className="sub_row_div">
                            <strong  className="data_text" style={{ minWidth: 100 }}>{chapter.activityname}</strong>
                          </div>
                          ))}
                        </div>
                      </div>
                    </div>)
                  }
                </div>
              },
              {
                title: 'Content name',
                render: (text, row) => <div className="sub_div">
                  {
                    row['activityviwed']?.map(data =>
                      data?.activities?.map(chapter => (<div className="sub_row_div">
                        <div className="sub_div">
                          <div  className="data_text" style={{ minWidth: 100 }}>{chapter.activityname}</div>
                        </div>
                      </div>
                      ))
                    )
                  }
                </div>
              },
              {
                title: 'Quick Quiz',
                render: (text, row) => <div className="sub_div">
                  {
                    row['activityviwed']?.map(data =>
                      data?.activities?.map(chapter => (<div className="sub_row_div">
                        <div className="hidden_div">
                          <div  className="data_text" style={{ minWidth: 100 }}>{chapter.activityname}</div>
                        </div>
                        <div className="sub_div">
                          <div  className="data_text" style={{ minWidth: 100 }}>{chapter.status}</div>
                        </div>
                      </div>
                      ))
                    )
                  }
                </div>
              },
            ]
          },
        ]}
        bordered
        scroll={{ x: 3000 }}
        pagination={{ defaultPageSize: 10 }}
        dataSource={activitySummaryData}
        loading={loading}
      />

    </div>
  );
};

export default LoginActivityReport;
